<template>
  <div
    class="modal fade"
    id="htmlEditorModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ title }}</b>
          </h4>
          <h6 class="modal-title">
            <b>({{ this.currentChars }}/39999)</b>
          </h6>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs">
            <li class="active">
              <a href="#htmlEditorEditorTab" data-toggle="tab">{{
                lang.HEM000
              }}</a>
            </li>
            <li>
              <a href="#htmlEditorPreviewTab" data-toggle="tab">{{
                lang.HEM001
              }}</a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane fade active in" id="htmlEditorEditorTab">
              <pre id="aceEditor"></pre>
            </div>

            <div class="tab-pane fade" id="htmlEditorPreviewTab">
              <div v-html="content"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.HEM002 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ace from "ace-builds";

export default {
  name: "HtmlEditorModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openModal() {
      $("#htmlEditorModal").modal("show");
    },
    closeModal() {
      $("#htmlEditorModal").modal("hide");
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#htmlEditorModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
      this.globals.$emit("getDataFromHtmlEditorModal", this.content);
    });

    this.globals.$off("sendDataToHtmlEditorModal");
    this.globals.$on("sendDataToHtmlEditorModal", (data) => {
      this.title = data.title;
      this.content = data.content || "";
      this.content.substring(0, 39999);
      this.aceEditor.setValue(this.content);
    });

    require("ace-builds/webpack-resolver");
    ace.require("ace/ext/language_tools");
    this.aceEditor = ace.edit("aceEditor");
    this.aceEditor.session.setMode("ace/mode/html");
    this.aceEditor.setTheme("ace/theme/tomorrow");
    this.aceEditor.on("blur", () => {
      this.content = this.aceEditor.getValue();
    });
    this.aceEditor.on("change", (data) => {
      let value = this.aceEditor.getValue();
      this.currentChars = value.length;
      if (value.length > 39999) {
        this.globals.showErrorSnackbar(this.lang.HEM003);
        try {
          this.aceEditor.session.getUndoManager().undo();
        } catch (error) {
          console.error("UndoManager Error", error);
        }
      }
    });
  },
  watch: {
    showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      title: "",
      content: "",
      aceEditor: null,
      currentChars: 0,
      lang: {
        HEM000: "HTML Editor",
        HEM001: "Preview",
        HEM002: "Close",
        HEM003: "Maximum characters reached",
      },
    };
  },
};
</script>

<style scoped>
#htmlEditorPreviewTab {
  margin-top: 10px;
  max-height: calc(100vh - 250px);
  overflow: auto;
}
#aceEditor {
  height: calc(100vh - 250px);
  margin: 0;
}

.nav {
  background-color: var(--color-primary);
}
.nav > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}
.nav > li.active > a {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// HtmlEditorModal.vue?e0e6838c